import { useCallback, useEffect, useReducer } from 'react';

const useHashState = (key: string): [state: string | undefined, setState: (state: string | undefined) => void] => {
    const prefix = `#${key}:`;
    const state = window.location.hash.startsWith(prefix) ? window.location.hash.substring(prefix.length) : undefined;

    // https://reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [, forceUpdate] = useReducer((s) => s + 1, 0);

    const handleHashChange = useCallback(() => {
        forceUpdate();
    }, [forceUpdate]);

    useEffect(() => {
        window.addEventListener('hashchange', handleHashChange, false);

        return () => {
            window.removeEventListener('hashchange', handleHashChange, false);
        };
    }, [handleHashChange]);

    const setState = useCallback(
        (newState: string | undefined) => {
            window.history.pushState(
                undefined,
                '',
                `${window.location.pathname}${window.location.search}${newState ? `${prefix}${newState}` : ''}`,
            );
            window.dispatchEvent(new HashChangeEvent('hashchange'));
        },
        [prefix],
    );

    return [state, setState];
};

export default useHashState;
